module.exports = __webpack_public_path__ + "img/CloseCombat.d87e34b0.png";